module.exports = __webpack_public_path__ + "c6440693edc1d2a11cd5a3540e15f97b.png";